export const businessClientInfo = {
  businessId: 'WZ-BIZ-2024-045',
  companyName: 'شركة النهضة التجارية المحدودة',
  companyNameEn: 'Al-Nahda Trading Company LLC',
  entityType: 'شركة ذات مسؤولية محدودة',
  crNumber: '1010567890',
  taxNumber: '300123456789003',
  registrationDate: '2020-03-15',
  accountStatus: 'نشط',
  accountStatusColor: '#1F8A70',
  accountManager: {
    name: 'أ. خالد المطيري',
    title: 'مدير حسابات الشركات',
    phone: '+966 50 555 7777',
    email: 'khaled.almutairi@wazin.sa',
    photo: null
  },
  primaryLawyer: {
    name: 'أ. سارة الأحمدي',
    title: 'المحامية المشرفة',
    phone: '+966 55 987 6543',
    email: 'sarah.ahmadi@wazin.sa',
    photo: null
  },
  contactInfo: {
    address: 'الرياض، حي العليا، برج الفيصلية، الدور 15',
    phone: '+966 11 234 5678',
    email: 'info@alnahda-trading.com',
    website: 'www.alnahda-trading.com'
  }
};

export const businessUsers = [
  {
    id: 'BU-001',
    name: 'محمد بن سعد العتيبي',
    email: 'mohammed@alnahda-trading.com',
    role: 'المدير التنفيذي',
    permissions: ['view_all', 'download_files', 'create_tickets', 'manage_account'],
    status: 'نشط',
    addedDate: '2020-03-20'
  },
  {
    id: 'BU-002',
    name: 'فاطمة بنت أحمد الشهري',
    email: 'fatima@alnahda-trading.com',
    role: 'مديرة الشؤون القانونية',
    permissions: ['view_all', 'download_files', 'create_tickets'],
    status: 'نشط',
    addedDate: '2020-04-10'
  },
  {
    id: 'BU-003',
    name: 'عبدالله بن محمد القحطاني',
    email: 'abdullah@alnahda-trading.com',
    role: 'مدير مالي',
    permissions: ['view_invoices', 'download_invoices'],
    status: 'نشط',
    addedDate: '2021-01-15'
  },
  {
    id: 'BU-004',
    name: 'نورة بنت عبدالرحمن الدوسري',
    email: 'noura@alnahda-trading.com',
    role: 'موظفة إدارية',
    permissions: ['view_only'],
    status: 'نشط',
    addedDate: '2022-06-01'
  }
];

export const businessPowerOfAttorneys = [
  {
    id: 'POA-BIZ-001',
    title: 'وكالة عامة للتمثيل القانوني',
    issueDate: '2020-03-20',
    expiryDate: '2026-03-20',
    status: 'سارية',
    statusColor: '#1F8A70',
    issuedFor: 'شركة وازن للمحاماة والاستشارات القانونية',
    scope: 'التمثيل القانوني الكامل في جميع القضايا والإجراءات القانونية',
    issuedBy: 'وزارة العدل',
    documentUrl: '/documents/poa-biz-001.pdf',
    grantedBy: 'محمد بن سعد العتيبي - المدير التنفيذي'
  },
  {
    id: 'POA-BIZ-002',
    title: 'وكالة خاصة لقضية تجارية',
    issueDate: '2023-05-15',
    expiryDate: '2025-05-15',
    status: 'سارية',
    statusColor: '#1F8A70',
    issuedFor: 'أ. سارة الأحمدي',
    scope: 'التمثيل في القضية رقم WZ-BIZ-2024-001',
    issuedBy: 'وزارة العدل',
    documentUrl: '/documents/poa-biz-002.pdf',
    grantedBy: 'محمد بن سعد العتيبي - المدير التنفيذي'
  }
];

export const businessContracts = [
  {
    id: 'CONTRACT-001',
    contractNumber: 'WZ-CON-2020-045',
    title: 'عقد الأتعاب السنوي',
    type: 'عقد أتعاب',
    startDate: '2020-03-15',
    endDate: '2025-03-15',
    status: 'ساري',
    statusColor: '#1F8A70',
    value: 150000,
    currency: 'ريال',
    description: 'عقد سنوي يشمل الاستشارات القانونية والتمثيل في القضايا التجارية والعمالية.',
    documentUrl: '/documents/contract-001.pdf',
    renewalDate: '2025-02-01',
    autoRenewal: true
  },
  {
    id: 'CONTRACT-002',
    contractNumber: 'WZ-CON-2023-156',
    title: 'اتفاقية الباقة الذهبية',
    type: 'باقة خدمات',
    startDate: '2023-06-01',
    endDate: '2024-06-01',
    status: 'ساري',
    statusColor: '#1F8A70',
    value: 200000,
    currency: 'ريال',
    description: 'باقة شاملة للاستشارات والتمثيل القانوني مع إدارة مستمرة للملفات.',
    documentUrl: '/documents/contract-002.pdf',
    renewalDate: '2024-05-01',
    autoRenewal: false
  }
];

export const businessInvoices = [
  {
    id: 'INV-001',
    invoiceNumber: 'WZ-INV-2024-1120',
    invoiceDate: '2024-11-20',
    dueDate: '2024-12-20',
    type: 'أتعاب محاماة',
    description: 'أتعاب القضية WZ-BIZ-2024-001 للربع الرابع.',
    amount: 45000,
    currency: 'ريال',
    status: 'مستحقة',
    statusColor: '#C8A45C',
    relatedCase: 'WZ-BIZ-2024-001',
    documentUrl: '/documents/invoice-001.pdf'
  },
  {
    id: 'INV-002',
    invoiceNumber: 'WZ-INV-2024-1015',
    invoiceDate: '2024-10-15',
    dueDate: '2024-11-15',
    type: 'مصاريف إضافية',
    description: 'رسوم خبير فني وترجمة مستندات.',
    amount: 8500,
    currency: 'ريال',
    status: 'مدفوعة',
    statusColor: '#1F8A70',
    paidDate: '2024-11-10',
    relatedCase: 'WZ-BIZ-2024-001',
    documentUrl: '/documents/invoice-002.pdf'
  },
  {
    id: 'INV-003',
    invoiceNumber: 'WZ-INV-2024-0920',
    invoiceDate: '2024-09-20',
    dueDate: '2024-10-20',
    type: 'أتعاب محاماة',
    description: 'أتعاب القضية WZ-BIZ-2024-002 للربع الثالث.',
    amount: 35000,
    currency: 'ريال',
    status: 'متأخرة',
    statusColor: '#D97757',
    relatedCase: 'WZ-BIZ-2024-002',
    documentUrl: '/documents/invoice-003.pdf'
  }
];

export const businessCases = [
  {
    id: 'WZ-BIZ-2024-001',
    caseNumber: 'WZ-BIZ-2024-001',
    clientFileNumber: 'CF-BIZ-045-001',
    caseType: 'دعوى تجارية',
    title: 'نزاع حول عقد توريد معدات',
    category: 'تجاري',
    currentStatus: 'قيد النظر',
    statusColor: '#1F8A70',
    authority: 'المحكمة التجارية بالرياض',
    authorityType: 'محكمة',
    circuit: 'الدائرة التجارية الأولى',
    registrationDateInWazin: '2023-06-15',
    lastUpdate: '2024-11-28',
    assignedLawyer: {
      name: 'أ. سارة الأحمدي',
      title: 'المحامية المشرفة',
      phone: '+966 55 987 6543',
      email: 'sarah.ahmadi@wazin.sa',
      photo: null
    },
    assistantLawyer: {
      name: 'أ. يوسف الغامدي',
      title: 'محامٍ مساعد',
      phone: '+966 50 888 9999',
      email: 'yousef.alghamdi@wazin.sa'
    },
    caseDetails: {
      subject: 'نزاع ناشئ عن عقد توريد معدات بقيمة 2,500,000 ريال نتيجة عدم الالتزام بالمواصفات الفنية ومدة التسليم.',
      grounds: [
        'عدم مطابقة المعدات للمواصفات المتفق عليها.',
        'تأخر في التسليم تسبب في أضرار تشغيلية على الشركة.',
        'رفض المورد استبدال المعدات المعيبة.'
      ],
      demands: [
        'فسخ العقد وإعادة المبالغ المدفوعة.',
        'التعويض عن الأضرار المباشرة وفوات المنفعة.',
        'إلزام المدعى عليه بالمصاريف والأتعاب.'
      ],
      legalPath: 'تم قيد الدعوى أمام المحكمة التجارية ومتابعة الإجراءات وفق المواعيد المحددة نظامًا.',
      legalOpinion: 'الموقف القانوني للشركة قوي ومدعوم بالعقد والمراسلات وتقرير فني أولي.'
    },
    parties: [
      {
        role: 'المدعي',
        name: 'شركة النهضة التجارية المحدودة',
        type: 'client',
        crNumber: '1010567890',
        capacity: 'شركة',
        address: 'الرياض، حي العليا',
        phone: '+966 11 234 5678',
        representative: 'محمد بن سعد العتيبي - المدير التنفيذي'
      },
      {
        role: 'المدعى عليه',
        name: 'مؤسسة الأفق للتجارة والمقاولات',
        type: 'opponent',
        crNumber: '1010789456',
        capacity: 'مؤسسة',
        address: 'جدة، حي الشاطئ',
        phone: '+966 12 555 8888',
        representative: 'عبدالعزيز بن فهد الشمري'
      }
    ],
    hearings: [
      {
        id: 'H1',
        date: '2023-07-15',
        day: 'الاثنين',
        time: '10:00 صباحًا',
        location: 'المحكمة التجارية - القاعة 2',
        status: 'منتهية',
        statusColor: '#94A3B8',
        notes: 'تم سماع مرافعة المدعي وتأجيل القضية للرد.',
        attendees: ['أ. سارة الأحمدي', 'وكيل المدعى عليه']
      },
      {
        id: 'H2',
        date: '2024-12-20',
        day: 'الجمعة',
        time: '11:00 صباحًا',
        location: 'المحكمة التجارية - القاعة 5',
        status: 'قادمة',
        statusColor: '#C8A45C',
        notes: 'جلسة للمرافعة النهائية ومناقشة التقرير الفني.',
        attendees: ['أ. سارة الأحمدي']
      }
    ],
    memorandums: [
      {
        id: 'MEM1',
        title: 'مذكرة الدعوى الابتدائية',
        type: 'مذكرة دعوى',
        submissionDate: '2023-06-15',
        submittedBy: 'أ. سارة الأحمدي',
        pages: 15,
        summary: 'مذكرة تأسيس الدعوى مع إرفاق المستندات الجوهرية.',
        documentUrl: '/documents/biz-memorandum-001.pdf',
        canDownload: true
      }
    ],
    submittedRequests: [
      {
        id: 'REQ1',
        requestNumber: 'ط-2023-BIZ-001',
        date: '2023-07-20',
        type: 'طلب خبير فني',
        title: 'طلب تعيين خبير لفحص المعدات',
        status: 'مكتمل',
        statusColor: '#1F8A70',
        description: 'طلب تعيين خبير فني محايد لفحص المعدات المتنازع عليها.',
        response: 'تمت الموافقة وتعيين المهندس أحمد السلمي.',
        documentUrl: '/documents/request-biz-001.pdf'
      }
    ],
    reports: [
      {
        id: 'REP1',
        reportNumber: 'ت-BIZ-001',
        date: '2023-08-15',
        title: 'تقرير الخبير الفني',
        type: 'تقرير خبرة',
        preparedBy: 'م. أحمد السلمي',
        summary: 'تقرير يثبت عدم مطابقة المعدات للمواصفات الفنية.',
        pages: 25,
        documentUrl: '/documents/report-biz-001.pdf',
        canDownload: true
      }
    ],
    sessionRecords: [
      {
        id: 'SR1',
        sessionNumber: 'ج-BIZ-001',
        date: '2023-07-15',
        title: 'محضر الجلسة الأولى',
        summary: 'محضر جلسة سماع أولية.',
        content: 'حضر وكيل المدعي وقدم مذكرة الدعوى، وقررت المحكمة منح مهلة للرد.',
        documentUrl: '/documents/session-biz-001.pdf',
        canDownload: true
      }
    ],
    authorityDecisions: [
      {
        id: 'AD1',
        decisionNumber: 'ق-2023-BIZ-001',
        date: '2023-07-15',
        type: 'قرار إجرائي',
        title: 'قرار تعيين خبير',
        summary: 'تعيين خبير فني لفحص المعدات محل النزاع.',
        issuedBy: 'قاضي الدائرة التجارية الأولى',
        documentUrl: '/documents/decision-biz-001.pdf',
        canDownload: true
      }
    ],
    attachments: [
      {
        id: 'ATT1',
        fileName: 'عقد التوريد الأصلي.pdf',
        fileType: 'PDF',
        fileSize: '4.2 MB',
        uploadDate: '2023-06-15',
        uploadedBy: 'الشركة',
        category: 'عقود',
        description: 'نسخة من عقد التوريد الموقع بين الطرفين.',
        documentUrl: '/documents/attachment-biz-001.pdf',
        canDownload: true
      },
      {
        id: 'ATT2',
        fileName: 'المراسلات البريدية.pdf',
        fileType: 'PDF',
        fileSize: '2.8 MB',
        uploadDate: '2023-06-15',
        uploadedBy: 'الشركة',
        category: 'مستندات',
        description: 'جميع المراسلات المتعلقة بموضوع النزاع.',
        documentUrl: '/documents/attachment-biz-002.pdf',
        canDownload: true
      }
    ],
    clientTickets: [
      {
        id: 'TKT1',
        ticketNumber: 'TK-BIZ-001',
        subject: 'استفسار عن الجلسة القادمة',
        status: 'مغلقة',
        statusColor: '#1F8A70',
        priority: 'عادي',
        createdDate: '2024-11-15',
        lastUpdate: '2024-11-16',
        messages: 2,
        assignedTo: 'أ. سارة الأحمدي'
      }
    ],
    additionalFees: [
      {
        id: 'FEE1',
        type: 'رسوم خبير فني',
        description: 'رسوم الخبير الفني لفحص المعدات.',
        amount: 7500,
        currency: 'ريال',
        status: 'مدفوعة',
        statusColor: '#1F8A70',
        paidDate: '2023-08-20',
        invoiceNumber: 'INV-2023-0820'
      }
    ]
  },
  {
    id: 'WZ-BIZ-2024-002',
    caseNumber: 'WZ-BIZ-2024-002',
    clientFileNumber: 'CF-BIZ-045-002',
    caseType: 'قضية عمالية جماعية',
    title: 'دعوى عمالية من خمسة موظفين سابقين',
    category: 'عمالي',
    currentStatus: 'تحت الإجراء',
    statusColor: '#C8A45C',
    authority: 'المحكمة العمالية بالرياض',
    authorityType: 'محكمة',
    circuit: 'الدائرة العمالية الثانية',
    registrationDateInWazin: '2024-09-10',
    lastUpdate: '2024-11-25',
    assignedLawyer: {
      name: 'أ. خالد المطيري',
      title: 'محامٍ',
      phone: '+966 50 555 7777',
      email: 'khaled.almutairi@wazin.sa'
    },
    parties: [
      {
        role: 'المدعى عليه',
        name: 'شركة النهضة التجارية المحدودة',
        type: 'client',
        crNumber: '1010567890',
        capacity: 'شركة'
      },
      {
        role: 'المدعون',
        name: 'خمسة موظفين سابقين',
        type: 'opponent',
        capacity: 'أفراد'
      }
    ],
    hearings: [
      {
        id: 'H1',
        date: '2024-12-10',
        day: 'الثلاثاء',
        time: '09:00 صباحًا',
        location: 'المحكمة العمالية - القاعة 3',
        status: 'قادمة',
        statusColor: '#C8A45C',
        notes: 'الجلسة الأولى لسماع أقوال الطرفين.'
      }
    ],
    memorandums: [],
    submittedRequests: [],
    reports: [],
    sessionRecords: [],
    authorityDecisions: [],
    attachments: [],
    clientTickets: [],
    additionalFees: []
  }
];

export const getBusinessCaseById = (caseId) =>
  businessCases.find((c) => c.id === caseId || c.caseNumber === caseId);

export const getActiveBusinessCases = () =>
  businessCases.filter((c) => c.currentStatus !== 'مغلقة' && c.currentStatus !== 'منتهية');

export const getClosedBusinessCases = () =>
  businessCases.filter((c) => c.currentStatus === 'مغلقة' || c.currentStatus === 'منتهية');

export const getTotalInvoicesAmount = () =>
  businessInvoices.reduce((sum, inv) => sum + inv.amount, 0);

export const getPendingInvoicesAmount = () =>
  businessInvoices
    .filter((inv) => inv.status === 'مستحقة' || inv.status === 'متأخرة')
    .reduce((sum, inv) => sum + inv.amount, 0);

export const getUpcomingHearings = () => {
  const allHearings = [];
  businessCases.forEach((caseItem) => {
    if (caseItem.hearings) {
      caseItem.hearings.forEach((hearing) => {
        if (hearing.status === 'قادمة') {
          allHearings.push({
            ...hearing,
            caseNumber: caseItem.caseNumber,
            caseTitle: caseItem.title
          });
        }
      });
    }
  });
  return allHearings;
};
